import axios from "axios";
import { api } from "~/router/apiConfig";

export function index(contractId, params = {}) {
  return axios.get(
    api.path("contractBalanceOverview.index", { contractId }),
    { params }
  );
}
